import { Address } from "@finway-group/shared/lib/models/company/address.interface"
import {
    PURCHASE_ORDER_DESCRIPTION_MAX_LENGTH,
    PURCHASE_ORDER_DESCRIPTION_MIN_LENGTH,
    PURCHASE_ORDER_NUMBER_MAX_LENGTH,
    PURCHASE_ORDER_NUMBER_MIN_LENGTH,
} from "@finway-group/shared/lib/models/purchaseOrder/purchaseOrder.validation"
import { validateAddressFormat } from "@finway-group/shared/lib/utils/validators/address.validator"
import { Rule } from "antd/lib/form"
import { isEmpty } from "lodash"
import { dateRules } from "~Components/forms/rules/common/date.rules"
import { generalRules } from "~Components/forms/rules/common/general.rules"
import { stringRules } from "~Components/forms/rules/common/string.rules"
import i18n from "~Shared/locales/i18n"
import { formatAddress } from "~Shared/utils/form.utils"

export const createDeliveryNoteFormRules = () => ({
    deliveryNoteOrderNumber: [
        generalRules.required,
        stringRules.noExcessWhitespace,
        // TODO [WEB-2043] introduce separate constants for DELIVERY_NOTE_NUMBER_MIN/MAX_LENGTH
        stringRules.minLength(PURCHASE_ORDER_NUMBER_MIN_LENGTH),
        stringRules.maxLength(PURCHASE_ORDER_NUMBER_MAX_LENGTH),
        stringRules.allowedCompanyNameCharsOnly,
    ] as Array<Rule>,
    dateOfIssue: [generalRules.required, dateRules.gobdCompliant] as Array<Rule>,
    deliveryLocation: [
        {
            required: false,
            validator: (_rule, value: Address | string) => {
                if (!value || (typeof value === "object" && isEmpty(value.addressLine1) && isEmpty(value.zip) && isEmpty(value.city) && isEmpty(value.country))) {
                    return Promise.resolve()
                }
                const formattedAddress = typeof value === "string" ? value : formatAddress(value)

                // If there's a value, validate the format
                return validateAddressFormat(formattedAddress) ? Promise.resolve() : Promise.reject(new Error(i18n.t("validation:invalid_address_format")))
            },
        },
    ] as Array<Rule>,
    description: [
        stringRules.noExcessWhitespace,
        // TODO [WEB-2043] introduce separate constants for DELIVERY_NOTE_DESCRIPTION_MIN/MAX_LENGTH
        stringRules.minLength(PURCHASE_ORDER_DESCRIPTION_MIN_LENGTH),
        stringRules.maxLength(PURCHASE_ORDER_DESCRIPTION_MAX_LENGTH),
        stringRules.allowedCompanyNameCharsOnly,
    ] as Array<Rule>,
})
